import React from "react";
import { Autocomplete, TextField, FormControl } from "@mui/material";
import { useIntl } from "react-intl";

const DropdownComponent = ({
  options,
  selectedValue,
  onChange,
  placeholder,
  noOptionsText = "",
  id = "dropdown-select",
  hasError = false,
}) => {
  const intl = useIntl();
  // Transform options to format expected by Autocomplete
  const transformedOptions = options.map((option) => ({
    id: option._id,
    label: option.text,
  }));

  // Find the selected option based on stored answer value
  const selectedOption =
    transformedOptions.find((opt) => opt.id === selectedValue) || null;

  const handleChange = (event, newValue) => {
    const value = newValue ? newValue.id : "";
    onChange(value);
  };

  return (
    <div className="col-md-4 col-sm-12 col-xs-12">
      <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
        <Autocomplete
          id={id}
          options={transformedOptions}
          value={selectedOption}
          onChange={handleChange}
          getOptionLabel={(option) => option.label || ""}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          clearOnEscape
          noOptionsText={
            noOptionsText || intl.formatMessage({ id: "no-results-found" })
          }
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={placeholder}
              error={hasError}
              sx={{
                "& .MuiOutlinedInput-root": {
                  height: "45px", // Decrease the height of the select input
                  "&.Mui-error .MuiOutlinedInput-notchedOutline": {
                    borderColor: "red !important",
                    borderWidth: "2px !important",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderRadius: "4px",
                    borderColor: hasError ? "red !important" : undefined,
                    borderWidth: hasError ? "2px !important" : undefined,
                  },
                  "& .MuiInputBase-input": {
                    paddingTop: "5px", // Adjust padding to center the text
                    paddingBottom: "5px",
                    paddingRight: "32px", // Add extra padding to prevent overlap with clear button
                    color: !selectedValue ? "gray" : "rgba(0, 0, 0, 0.87)", // Set text color to gray if no value is selected, otherwise use default black
                    "&::placeholder": {
                      color: "gray",
                      opacity: 1,
                    },
                  },
                },
              }}
            />
          )}
          componentsProps={{
            paper: { sx: { "& .MuiAutocomplete-option": { color: "#000000" } } },
          }}
          sx={{
            "& .MuiAutocomplete-inputRoot": {
              paddingTop: "0px",
              paddingBottom: "0px",
              paddingRight: "0px", // Ensure no extra padding on right
            },
            "& .MuiAutocomplete-clearIndicator": {
              padding: "4px",
              marginRight: "4px",
              marginLeft: "4px", // Add left margin to create space from text
              "@media (max-width: 600px)": {
                padding: "12px",
                minWidth: "44px",
                minHeight: "44px",
              },
            },
            "& .MuiAutocomplete-listbox": {
              "& .MuiAutocomplete-option": {
                "&.Mui-focused": {
                  backgroundColor: "rgba(0, 0, 0, 0.04)", // Light gray background on hover/focus
                },
                "@media (max-width: 600px)": {
                  padding: "12px 16px",
                  minHeight: "44px",
                },
              },
            },
          }}
        />
      </FormControl>
    </div>
  );
};

export default DropdownComponent;
